<div class="layout-topbar top-bar-custom">
  <div class="topbar-left">
    <img id="logo-mobile" class="logo-desktop" src="../../../../assets/images/header-white-logo.png" alt="PaperTrl"/>
  </div>
</div>
<div class="exception-body">
  <div class="exception-content">
    <div class="exception-detail">
      <div class="grid">
        <p-card class="card-custom" styleClass="p-card-shadow">
          <div class="card-custom-padding">
            <h5 class="card-header-custom">PASSWORD RESET</h5>
            <div class="p-fluid">
              <form [formGroup]="passwordResetForm" (ngSubmit)="sendLink(passwordResetForm.value)">

                <div class="col-12">
                  <div class="field margin-between-fields-headers">
                     <span class="p-float-label">
                      <input class="p-inputtext-lg" formControlName="email" id="float-input" type="email" pInputText>
                      <label for="float-input">Enter your email address</label>
                     </span>
                    <div class="p-invalid  text-align-left"
                         *ngIf="passwordResetForm.get('email').dirty && passwordResetForm.get('email').errors">
                      <div *ngIf="passwordResetForm.get('email').errors.required">Email Address is required</div>

                    </div>
                  </div>
                </div>

                <div class="pwrd-reset-btn-div col-12 md:col-12 margin-between-fields-input">
                  <button type="submit" pButton class="pwrd-reset-btn p-button-lg"
                          [disabled]="passwordResetForm.invalid||disableSubmitButton"
                          label="SEND PASSWORD RESET LINK"></button>
                </div>

                <div class="p-fluid">
                  <div class="col-12 md:col-12 margin-between-buttons">
                    <p class="vendor-link">Back to login <span (click)="loginRedirect()">Click Here</span></p>
                  </div>
                </div>
              </form>

              <div class="p-fluid">
                <div class="col-12 md:col-12 margin-between-buttons">
                  <p class="goBack-link">If we can find an account with that email address,<br> we will send a password
                    reset link.</p>
                </div>
              </div>
            </div>
          </div>
        </p-card>
      </div>
    </div>
  </div>
</div>
<p-toast position="bottom-right"></p-toast>
